import { VBadge } from "@/components/ui";
import type {
  AssetStatus,
  DeploymentStatus,
  DossierStatus,
  RequestStatus,
} from "@/v2/shared/model";
import {
  assetStatusMeta,
  deploymentStatusMeta,
  dossierStatusMeta,
  requestStatusMeta,
} from "@/v2/shared/statusMeta";

export function RequestStatusBadge({ status }: { status: RequestStatus }): React.JSX.Element {
  const meta = requestStatusMeta[status];
  return <VBadge color={meta.color}>{meta.label}</VBadge>;
}

export function DossierStatusBadge({ status }: { status: DossierStatus }): React.JSX.Element {
  const meta = dossierStatusMeta[status];
  return <VBadge color={meta.color}>{meta.label}</VBadge>;
}

export function DeploymentStatusBadge({
  status,
}: {
  status: DeploymentStatus;
}): React.JSX.Element {
  const meta = deploymentStatusMeta[status];
  return <VBadge color={meta.color}>{meta.label}</VBadge>;
}

export function AssetStatusBadge({ status }: { status: AssetStatus }): React.JSX.Element {
  const meta = assetStatusMeta[status];
  return <VBadge color={meta.color}>{meta.label}</VBadge>;
}
